<div class="borderTopDivider">
    <mat-tab-group mat-stretch-tabs>
        <mat-tab>
            <ng-template mat-tab-label>
                <span translate>COMMONS.MAIN_DATA</span>
            </ng-template>
            <mat-card style="border-radius: 0; height: 100%; position: relative">
                <div style="display: flex; flex-direction: column">
                    <div style="width: 100%">
                        <div>
                            <div>
                                <button style="white-space: nowrap; border: 0px; background: transparent; width: 100%">
                                    <div class="circleUserSmall bgGreenDark">
                                        {{ accountDetail.AccountName.trim().slice(0, 2).toLocaleUpperCase() }}
                                    </div>
                                </button>
                                <h4 class="title-center">{{ accountDetail.AccountName }}</h4>
                            </div>
                        </div>
                        <div class="flex-column">
                            <mat-form-field appearance="outline" style="font-size: 12px !important">
                                <mat-label translate>EDIT_SUBSCRIPTION.ACC</mat-label>
                                <input matInput [ngModel]="accountDetail.AccountName" [readonly]="true" disabled />
                            </mat-form-field>
                            <!-- <mat-form-field *ngIf="checked" appearance="outline" style="font-size: 12px!important;">
                                <mat-label>NickName</mat-label>
                                <input matInput [ngModel]="accountDetail.NickName" [readonly]="true" disabled />
                            </mat-form-field> -->
                            <mat-form-field appearance="outline" style="font-size: 12px !important">
                                <mat-label translate>EDIT_SUBSCRIPTION.DATE</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="cD"
                                    [(ngModel)]="accountDetail.CreationDate"
                                    name="CreationDate"
                                    readonly="true"
                                    disabled
                                />
                                <mat-datepicker-toggle matSuffix [for]="cD"></mat-datepicker-toggle>
                                <mat-datepicker #cD disabled="true"></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field appearance="outline" style="font-size: 12px !important">
                                <mat-label translate>EDIT_SUBSCRIPTION.EXPIRATION_DATE</mat-label>
                                <input
                                    matInput
                                    [min]="minDate"
                                    [matDatepicker]="eD"
                                    (ngModelChange)="eDateValueChange(eD, true)"
                                    [(ngModel)]="accountDetail.ExpirationDate"
                                    [ngModelOptions]="{ standalone: true }"
                                    name="ExpirationDate"
                                    readonly="true"
                                />
                                <mat-datepicker-toggle matSuffix [for]="eD"></mat-datepicker-toggle>
                                <mat-datepicker #eD disabled="false"></mat-datepicker>
                            </mat-form-field>

                            <div style="display: flex; justify-content: space-between">
                                <div>
                                    <button mat-flat-button color="primary" (click)="closeDrawer()">
                                        <span translate>M_CLOSE</span>
                                    </button>
                                </div>
                                <div>
                                    <button
                                        mat-flat-button
                                        class="left"
                                        color="primary"
                                        (click)="eDateValueChange(copyOfAccountDetail.ExpirationDate, false)"
                                        [disabled]="!dateChanged"
                                    >
                                        <span translate>B_CANCEL</span>
                                    </button>
                                    <button
                                        mat-flat-button
                                        color="primary"
                                        [disabled]="!dateChanged"
                                        (click)="
                                            addAccountSubscriptionAssociation(accountDetail.AccountName, accountDetail.ExpirationDate, true)
                                        "
                                    >
                                        <span translate>B_SAVE</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span translate>EDIT_SUBSCRIPTION.ROL</span>
            </ng-template>
            <mat-card style="border-radius: 0; height: 100%; position: relative">
                <mat-card-content class="flex-column" style="height: 100%">
                    <!-- <mat-checkbox *ngFor="let Role of realRoles; index as i" [checked]="Role.Value" [id]="Role.RoleName"
                    (change)="onValueChange($event, i)" [disabled]="disableRole(Role)" [matTooltip]="Role.Description">
                    <div style="display: flex;flex-direction: column;">
                        <span>{{Role.RoleName}}</span>
                    </div>
                </mat-checkbox> -->
                    <div *ngIf="accountDetail.ShowAdministrativeRoles || accountDetail.ShowApplicationeRoles">
                        <div
                            style="display: flex; flex-direction: column; margin-bottom: 15px"
                            *ngIf="accountDetail.ShowAdministrativeRoles"
                        >
                            <div class="subTitleTabContent" translate>ROLES_STRINGS.M_ADMIN_ROLES</div>
                            <mat-checkbox
                                *ngFor="let Role of administrativeRoles; index as i"
                                [checked]="Role.Value"
                                [id]="Role.RoleName"
                                (change)="onValueChange($event, i, 'administrativeRoles')"
                                [disabled]="disableRole(Role)"
                                [ngClass]="disableRole(Role) ? 'disable-checkbox' : ''"
                            >
                                <div style="display: flex; flex-direction: column">
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'CO-USER-ADMIN'"
                                        ><b><span translate>ROLES_STRINGS.COUSERADMIN</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_COUSERADMIN</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'USER-ADMIN'"
                                        ><b><span translate>ROLES_STRINGS.USERADMIN</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_USERADMIN</span></span
                                    >
                                </div>
                            </mat-checkbox>
                        </div>

                        <div style="display: flex; flex-direction: column" *ngIf="accountDetail.ShowApplicationeRoles">
                            <div class="subTitleTabContent" translate>ROLES_STRINGS.M_APP_ROLES</div>

                            <mat-checkbox
                                *ngFor="let Role of applicationRoles; index as i"
                                [checked]="Role.Value"
                                [id]="Role.RoleName"
                                (change)="onValueChange($event, i, 'applicationRoles')"
                            >
                                <div style="display: flex; flex-direction: column">
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'POWER-USER-SCHEDULER'"
                                        ><b><span translate>ROLES_STRINGS.POWERUSERSCHED</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_POWERUSERSCHED</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'POWER-USER-REPORT'"
                                        ><b><span translate>ROLES_STRINGS.POWERUSERREPORT</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_POWERUSERREPORT</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'POWER-USER'"
                                        ><b><span translate>ROLES_STRINGS.POWERUSER</span></b> -
                                        <span translate>ROLES_STRINGS.M_DESC_POWERUSER</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'SECURITY-ADMIN'"
                                        ><b><span translate>ROLES_STRINGS.SECURITYADMIN</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_SECURITYADMIN</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'APPLICATION-ADMIN'"
                                        ><b><span translate>ROLES_STRINGS.APPLICADMIN</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_APPLICADMIN</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'MAGOAPI-USER'"
                                        ><b><span translate>ROLES_STRINGS.MAGOAPIUSER</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_MAGOAPIUSER</span></span
                                    >
                                    <span style="font-size: 0.9rem" *ngIf="Role.RoleName === 'CONSULTATION-ONLY'"
                                        ><b><span translate>ROLES_STRINGS.CONSULTATIONONLY</span></b> -
                                        <span class="small" translate>ROLES_STRINGS.M_DESC_CONSULTATIONONLY</span></span
                                    >
                                </div>
                            </mat-checkbox>
                        </div>
                        <!-- <div *ngIf="showRoles"> -->
                        <div style="display: flex; justify-content: space-between">
                            <div>
                                <button mat-flat-button color="primary" (click)="closeDrawer()">
                                    <span translate>M_CLOSE</span>
                                </button>
                            </div>
                            <div>
                                <button mat-flat-button class="left" color="primary" [disabled]="nothingHasChanged()" (click)="cancel()">
                                    <span translate>B_CANCEL</span>
                                </button>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    [disabled]="nothingHasChanged()"
                                    (click)="onSaveChanges(applicationRoles, administrativeRoles)"
                                >
                                    <span translate>B_SAVE</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="accountDetail.ShowAdministrativeRoles == false && accountDetail.ShowApplicationeRoles == false"
                        class="message-box info"
                    >
                        <span translate>SUBSCRIPTIONS_ACCOUNTS.NO_ROLES_TO_ASSIGN</span>
                    </div>
                    <!-- </div> -->
                </mat-card-content>
            </mat-card>
        </mat-tab>

        <mat-tab *ngIf="isEditable(accountDetail.AccountName)">
            <ng-template mat-tab-label>
                <span translate>M_PERS_DATA</span>
            </ng-template>
            <tb-edit-account [accountName]="accountDetail.AccountName" [imInAccountManegement]="false" (close)="closeDrawer()">
            </tb-edit-account>
        </mat-tab>

        <button>x</button>
    </mat-tab-group>
</div>
